import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export const AI_USAGE_KEY = 'aiUsage';

interface AIUsageItem {
  usageCount: number;
  usageLimit: number;
  requestType: string;
  creditType: 'plan' | 'pack';
  expirationDate?: Date;
  stripePricingId?: string;
}

interface AIUsageResponse {
  items: AIUsageItem[];
}

export function useAIUsage(disabled?: boolean) {
  const url = '/user/ai-usage';
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);

  return useQuery({
    queryKey: [AI_USAGE_KEY],
    queryFn: () =>
      request(url, {
        method: 'GET',
      })
        .then<AIUsageResponse>(res => res)
        .catch(err => {
          if (err?.response?.status === 401) {
            notifyError({
              title: t('common:components.user.disconnectedError'),
            });
            return;
          }
          notifyError({
            title: t('common:components.user.fetchGenericError'),
          });
        }),

    refetchOnWindowFocus: false,
    enabled: !disabled,
  });
}
